import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, mergeProps as _mergeProps, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1881568c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "library-form-btn" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("新建材料")
const _hoisted_4 = { class: "text-grey" }
const _hoisted_5 = { class: "text-grey" }
const _hoisted_6 = { class: "ant-drawer-footer" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" 确定 ")

export function render(_ctx, _cache) {
  const _component_hmd_empty_link = _resolveComponent("hmd-empty-link")
  const _component_a_button = _resolveComponent("a-button")
  const _component_a_input = _resolveComponent("a-input")
  const _component_a_form_item = _resolveComponent("a-form-item")
  const _component_a_col = _resolveComponent("a-col")
  const _component_a_row = _resolveComponent("a-row")
  const _component_MaterialCategorySelectAdd = _resolveComponent("MaterialCategorySelectAdd")
  const _component_unit_select = _resolveComponent("unit-select")
  const _component_brand_select = _resolveComponent("brand-select")
  const _component_number_input = _resolveComponent("number-input")
  const _component_a_switch = _resolveComponent("a-switch")
  const _component_a_textarea = _resolveComponent("a-textarea")
  const _component_attachment_table = _resolveComponent("attachment-table")
  const _component_a_form = _resolveComponent("a-form")
  const _component_a_skeleton = _resolveComponent("a-skeleton")
  const _component_form_btn = _resolveComponent("form-btn")
  const _component_a_drawer = _resolveComponent("a-drawer")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isEdit )
      ? (_openBlock(), _createBlock(_component_hmd_empty_link, {
          key: 0,
          onClick: _ctx.showEditDrawer
        }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        }, 8, ["onClick"]))
      : _createCommentVNode("", true),
    (!_ctx.isEdit )
      ? (_openBlock(), _createBlock(_component_a_button, {
          key: 1,
          type: "primary",
          onClick: _ctx.showCreateDrawer
        }, {
          default: _withCtx(() => [
            _renderSlot(_ctx.$slots, "default", {}, () => [
              _hoisted_3
            ], true)
          ]),
          _: 3
        }, 8, ["onClick"]))
      : _createCommentVNode("", true),
    _createVNode(_component_a_drawer, {
      visible: _ctx.visible,
      "onUpdate:visible": _cache[11] || (_cache[11] = $event => ((_ctx.visible) = $event)),
      width: 780,
      "confirm-loading": _ctx.createLoading || _ctx.editLoading,
      keyboard: false,
      centered: true,
      "mask-closable": false,
      destroyOnClose: true,
      bodyStyle: {paddingBottom:'60px'},
      onOk: _ctx.submit,
      onCancel: _ctx.closeDrawer
    }, {
      title: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.isEdit ? "编辑" : "新建") + "材料", 1)
      ]),
      default: _withCtx(() => [
        _createVNode(_component_a_skeleton, {
          loading: _ctx.detailLoading,
          active: "",
          paragraph: {rows:20}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form, { layout: "vertical" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_row, { gutter: 10 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_col, { span: 12 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_form_item, _mergeProps({ label: "材料名称" }, _ctx.validateInfos.name), {
                          default: _withCtx(() => [
                            _createVNode(_component_a_input, {
                              value: _ctx.formRef.name,
                              "onUpdate:value": _cache[0] || (_cache[0] = $event => ((_ctx.formRef.name) = $event)),
                              valueModifiers: { trim: true },
                              placeholder: "请输入材料名称",
                              "allow-clear": "",
                              maxlength: 50
                            }, {
                              suffix: _withCtx(() => [
                                _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.formRef.name.length) + "/50", 1)
                              ]),
                              _: 1
                            }, 8, ["value"])
                          ]),
                          _: 1
                        }, 16)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_col, { span: 12 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_form_item, _mergeProps({ label: "规格型号" }, _ctx.validateInfos.model), {
                          default: _withCtx(() => [
                            _createVNode(_component_a_input, {
                              value: _ctx.formRef.model,
                              "onUpdate:value": _cache[1] || (_cache[1] = $event => ((_ctx.formRef.model) = $event)),
                              valueModifiers: { trim: true },
                              placeholder: "请输入规格型号",
                              "allow-clear": "",
                              maxlength: 1000
                            }, {
                              suffix: _withCtx(() => [
                                _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.formRef.model.length) + "/1000", 1)
                              ]),
                              _: 1
                            }, 8, ["value"])
                          ]),
                          _: 1
                        }, 16)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_row, { gutter: 10 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_col, { span: 12 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_form_item, _mergeProps({ label: "所属分类" }, _ctx.validateInfos.materialCategoryId), {
                          default: _withCtx(() => [
                            _createVNode(_component_MaterialCategorySelectAdd, {
                              value: _ctx.formRef.materialCategoryId,
                              "onUpdate:value": _cache[2] || (_cache[2] = $event => ((_ctx.formRef.materialCategoryId) = $event)),
                              onChange: _ctx.onMaterialCategoryChange
                            }, null, 8, ["value", "onChange"])
                          ]),
                          _: 1
                        }, 16)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_col, { span: 12 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_form_item, _mergeProps({ label: "结算单位" }, _ctx.validateInfos.unitId), {
                          default: _withCtx(() => [
                            _createVNode(_component_unit_select, {
                              addUnit: true,
                              value: _ctx.formRef.unitId,
                              "onUpdate:value": _cache[3] || (_cache[3] = $event => ((_ctx.formRef.unitId) = $event))
                            }, null, 8, ["value"])
                          ]),
                          _: 1
                        }, 16)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_row, { gutter: 10 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_col, { span: 12 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_form_item, _mergeProps({ label: "品牌" }, _ctx.validateInfos.materialCategoryBrandId), {
                          default: _withCtx(() => [
                            _createVNode(_component_brand_select, {
                              value: _ctx.formRef.materialCategoryBrandId,
                              "onUpdate:value": _cache[4] || (_cache[4] = $event => ((_ctx.formRef.materialCategoryBrandId) = $event)),
                              "category-id": _ctx.formRef.materialCategoryId,
                              disabled: !_ctx.formRef.materialCategoryId,
                              brandList: _ctx.formRef.brandList,
                              "onUpdate:brandList": _cache[5] || (_cache[5] = $event => ((_ctx.formRef.brandList) = $event))
                            }, null, 8, ["value", "category-id", "disabled", "brandList"])
                          ]),
                          _: 1
                        }, 16)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_col, { span: 12 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_form_item, _mergeProps({ label: "预算成本价(元)" }, _ctx.validateInfos.costPrice), {
                          default: _withCtx(() => [
                            _createVNode(_component_number_input, {
                              value: _ctx.formRef.costPrice,
                              "onUpdate:value": _cache[6] || (_cache[6] = $event => ((_ctx.formRef.costPrice) = $event)),
                              class: "w100",
                              maxLength: 8,
                              placeholder: "请输入",
                              isEdit: _ctx.isEdit
                            }, null, 8, ["value", "isEdit"])
                          ]),
                          _: 1
                        }, 16)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_row, { gutter: 10 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_col, { span: 12 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_form_item, _mergeProps({ label: "市场销售价(元)" }, _ctx.validateInfos.salesPrice), {
                          default: _withCtx(() => [
                            _createVNode(_component_number_input, {
                              value: _ctx.formRef.salesPrice,
                              "onUpdate:value": _cache[7] || (_cache[7] = $event => ((_ctx.formRef.salesPrice) = $event)),
                              class: "w100",
                              placeholder: "请输入",
                              maxLength: 6,
                              isEdit: _ctx.isEdit
                            }, null, 8, ["value", "isEdit"])
                          ]),
                          _: 1
                        }, 16)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_col, { span: 12 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_form_item, _mergeProps({ label: "是否启用" }, _ctx.validateInfos.enable), {
                          default: _withCtx(() => [
                            _createVNode(_component_a_switch, {
                              checked: _ctx.formRef.enable,
                              "onUpdate:checked": _cache[8] || (_cache[8] = $event => ((_ctx.formRef.enable) = $event)),
                              "checked-children": "启用",
                              "un-checked-children": "禁用"
                            }, null, 8, ["checked"])
                          ]),
                          _: 1
                        }, 16)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_form_item, _mergeProps({ label: "备注" }, _ctx.validateInfos.remark), {
                  default: _withCtx(() => [
                    _createVNode(_component_a_textarea, {
                      value: _ctx.formRef.remark,
                      "onUpdate:value": _cache[9] || (_cache[9] = $event => ((_ctx.formRef.remark) = $event)),
                      "show-count": "",
                      placeholder: "请输入说明，最多200字",
                      rows: 4,
                      maxlength: 200
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }, 16),
                _createVNode(_component_a_form_item, _mergeProps({ label: "上传附件" }, _ctx.validateInfos.fileList), {
                  default: _withCtx(() => [
                    _createVNode(_component_attachment_table, {
                      class: "not-card",
                      value: _ctx.formRef.fileList,
                      "onUpdate:value": _cache[10] || (_cache[10] = $event => ((_ctx.formRef.fileList) = $event)),
                      "allow-edit": true,
                      "biz-id": _ctx.id,
                      "biz-type": "MATERIAL"
                    }, null, 8, ["value", "biz-id"])
                  ]),
                  _: 1
                }, 16)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["loading"]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_a_button, { onClick: _ctx.closeDrawer }, {
            default: _withCtx(() => [
              _hoisted_7
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_a_button, {
            type: "primary",
            onClick: _ctx.submit,
            loading: _ctx.createLoading || _ctx.editLoading
          }, {
            default: _withCtx(() => [
              _hoisted_8
            ]),
            _: 1
          }, 8, ["onClick", "loading"])
        ]),
        _createVNode(_component_form_btn, { showAddUnit: true })
      ]),
      _: 1
    }, 8, ["visible", "confirm-loading", "onOk", "onCancel"])
  ]))
}